<ng-content select="[pmd-card-avatar], [pmdCardAvatar]"></ng-content>
<div class="flex-grow-1">
	<ng-content
		  select="pmd-card-title, pmd-card-subtitle,
		  [pmd-card-title], [pmd-card-subtitle],
		  [pmdCardTitle], [pmdCardSubtitle]"></ng-content>
</div>	
<ng-content></ng-content>